import { render, staticRenderFns } from "./FerramentasCarousel.vue?vue&type=template&id=662f6932"
import script from "./FerramentasCarousel.vue?vue&type=script&lang=js"
export * from "./FerramentasCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports